// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

type QuoteLineState = {
    quoteLinesNotes: {
        [key: string]: string;
    };
};

const initialState: QuoteLineState = {
    quoteLinesNotes: {}
};

const reducer = {
    "xQuoteDetails/SetLineNotes": (draft: Draft<QuoteLineState>, action: { note: string; productId: string }) => {

        draft.quoteLinesNotes[action.productId] = action.note
    },
};

const xQuoteDetails = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xQuoteDetails = xQuoteDetails;

export type xQuoteLineState = {
    xQuoteDetails: QuoteLineState;
};

type xQuoteLineStateReducers = {
    quoteLinesNotes: typeof xQuoteDetails;
};

export type xS3UploadFilerActions = Parameters<xQuoteLineStateReducers[keyof xQuoteLineStateReducers]>[1] | AnyAction;

